import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { ReactComponent as IconAdd } from '@src/assets/icons/iconAddGrey.svg'

interface Props {
  title: string
  onCreate?: () => void
}

export default function SubTitle({ title, onCreate }: Props) {
  return (
    <Grid
      container
      display="flex"
      justifyContent="space-between"
      sx={{ marginTop: 3, marginBottom: 2 }}>
      <Grid item>
        <Typography component="div" variant="h6">
          {title}
        </Typography>
      </Grid>
      <Grid item sx={{ paddingRight: 2 }}>
        {onCreate && (
          <Box
            sx={{
              cursor: 'pointer',
              '&>svg': { width: 20, height: 20 },
            }}
            onClick={onCreate}>
            <IconAdd />
          </Box>
        )}
      </Grid>
    </Grid>
  )
}
